import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=68d8a586&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports